import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, Row, Col } from 'reactstrap';
import { BASE_URL } from '../../../constants';

function AddPackage(props) {

    const [errMsg, setErrMsg] = useState(null);
    const [title, setTitle] = useState('');
    const [productId, setProductId] = useState('');
    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState(null);
    const [allowedProperties, setAllowedProperties] = useState(null);
    const [allowedUsers, setAllowedUsers] = useState(null);
    const [hasTrial, setHasTrial] = useState(1);
    const [trialDays, setTrialDays] = useState(null);
    const navigate = useNavigate();
    console.log(trialDays, 'trialDays')

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Authorization token is missing.');
            }

            const response = await axios.post(`${BASE_URL}/package/add`, {
                title,
                description,
                amount,
                ios_product_id: productId,
                allowed_properties: allowedProperties,
                allowed_users: allowedUsers,
                has_trial: hasTrial,
                trial_days: trialDays || null
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.data.status) {
                navigate('/package');
            } else {
                console.log(response.data.message)
                setErrMsg(response.data.message);
            }
        } catch (error) {
            console.log(error)

            setErrMsg(error);
        }

    };

    return (
        <div className="content">
            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

            <h3>Add Package</h3>
            <Card>
                <CardBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="title">Title*</Label>
                                    <Input type="text" name="title" id="title" value={title} onChange={(e) => setTitle(e.target.value)} />
                                </FormGroup>
                            </Col>

                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="amount">Amount*</Label>
                                    <Input type="number" name="amount" id="amount" value={amount} onChange={(e) => setAmount(e.target.value)} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="allowedProperties">Allowed Properties*</Label>
                                    <Input type="number" name="allowedProperties" id="allowedProperties" value={allowedProperties} onChange={(e) => setAllowedProperties(e.target.value)} />
                                </FormGroup>
                            </Col>

                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="allowedUsers">Allowed Users*</Label>
                                    <Input type="number" name="allowedUsers" id="allowedUsers" value={allowedUsers} onChange={(e) => setAllowedUsers(e.target.value)} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="description">Description*</Label>
                                    <Input type="textarea" name="description" id="description" value={description} onChange={(e) => setDescription(e.target.value)} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="productId">IOS Product ID</Label>
                                    <Input type="text" name="productId" id="productId" value={productId} onChange={(e) => setProductId(e.target.value)} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label check>
                                        <Input type="checkbox" checked={!!hasTrial} style={{ transform: 'scale(1.2)', marginRight: '10px' }} onChange={(e) => setHasTrial(e.target.checked ? 1 : 0)} />{' '}
                                        Trial
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>

                        {hasTrial == 1 && (
                            <Row>
                                <Col xs="6">
                                    <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                        <Label for="trialDays">Trial Days</Label>
                                        <Input type="number" name="trialDays" id="trialDays" value={trialDays} onChange={(e) => setTrialDays(e.target.value)} />
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}

                        <Button color="primary" type="submit">Submit</Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}

export default AddPackage;
